module.exports = __webpack_public_path__ + "Server-Unknown-AzureCloudService.15e84f7b584120328f59abaa2c784162.hashedasset.svg";